import React, { useRef, useEffect, useState } from 'react';
import styles from './Contact.module.css';
import Footer from './Footer';

const BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;
const contactBg = `${BASE_URL}/bg-contact.JPG`;
const contactCards = [
  {
    image: `${BASE_URL}/contact-1.JPG`,
    text: 'Ready to book your next tattoo or collaborate on a custom design? Reach out for appointments, consultations, or creative partnerships in Atlanta and beyond.'
  },
  {
    image: `${BASE_URL}/contact-2.JPG`,
    text: 'Email: lalo@tattoosbylalo.com\nPhone: (404) 555-1234\nI respond promptly to all inquiries—let’s connect and discuss your ideas!'
  },
  {
    image: `${BASE_URL}/contact-3.jpeg`,
    text: 'Follow @tattoosbylalo on Instagram for the latest works, behind-the-scenes, and client stories. Stay inspired and see why clients trust Lalo for their most meaningful tattoos.'
  }
];

const Contact: React.FC = () => {
  const [showArrow, setShowArrow] = useState(true);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!containerRef.current) return;
      const scrollTop = containerRef.current.scrollTop;
      const sectionHeight = containerRef.current.offsetHeight;
      setShowArrow(scrollTop < sectionHeight / 2);
    };
    const container = containerRef.current;
    if (container) {
      container.addEventListener('scroll', handleScroll);
    }
    return () => {
      if (container) {
        container.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  return (
    <div ref={containerRef} className={styles.contactPage} style={{overflowY: 'auto', height: '100vh'}}>
      <section className={styles.heroSection}>
        <div
          className={styles.heroSection}
          style={{ backgroundImage: `url('${contactBg}')` }}
        >
          <div className={styles.heroOverlay}>
            <h1 className={styles.heroTitle}>CONTACT</h1>
          </div>
          {showArrow && (
            <div className={styles.arrowDown} onClick={() => {
              if (containerRef.current) {
                const sections = containerRef.current.querySelectorAll('section');
                if (sections.length > 1) {
                  (sections[1] as HTMLElement).scrollIntoView({ behavior: 'smooth' });
                }
              }
            }}>
              <svg width="32" height="32" viewBox="0 0 32 32">
                <polyline points="8,12 16,20 24,12" fill="none" stroke="white" strokeWidth="4" strokeLinecap="round" />
              </svg>
            </div>
          )}
        </div>
      </section>
      <section className={styles.contentSection}>
        <div className={styles.cardsContainer}>
          {contactCards.map((card, idx) => (
            <div className={styles.card} key={idx}>
              <img src={card.image} alt="Contact info" className={styles.cardImage} />
              <div className={styles.cardText}>{card.text}</div>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Contact; 